import React, { useState } from "react";
import { FiX, FiInfo } from "react-icons/fi";
import { FaUser, FaRegCalendarAlt, FaShieldAlt } from "react-icons/fa";
import { postAssetReturnRequest } from "../../ApiHelper/url_Helpers";
import { toasterError, toasterSuccess } from "../../Components/toaster";

const AssetReturnModal = ({ isOpen, onClose, asset, assignmentId }) => {
  const [returnTo, setReturnTo] = useState("Company");
  const [reason, setReason] = useState("");
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await postAssetReturnRequest({
        asset_id: assignmentId || asset?.id,
        reason: reason,
        remarks: remarks
      });
      toasterSuccess("Return request submitted successfully");
      onClose();
    } catch (error) {
      console.error("Return error:", error);
      toasterError("Failed to submit return request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-[#f8fafc] rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-xl flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-start p-3 border-b border-gray-200 bg-white rounded-t-xl">
          <div>
            <h2 className="text-xl font-bold text-gray-800">Asset Return Request</h2>
            <p className="text-sm text-gray-500 mt-1">Fill in the details below to request an asset return.</p>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-md transition-colors">
            <FiX className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="flex flex-col md:flex-row p-4 ">
          <div className="flex-1 bg-white p-6 rounded-xl border border-gray-100 shadow-sm space-y-6">
            <div>
              <h4 className="text-lg font-semibold text-gray-800 mb-4">Return To</h4>
              <div className="space-y-4">

                <div className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-md p-3">
                  <FiInfo className="text-blue-500 shrink-0" />
                  <p className="text-sm text-blue-600 font-medium">All returned assets will be returned to the company</p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Request Details</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Reason for return  <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    rows={2}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    className="w-full border border-gray-200 rounded-md p-2 text-sm focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className=" sticky bottom-0 flex justify-end gap-3 p-6 border-t border-gray-200 bg-white rounded-b-xl mt-auto">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 bg-[#00bcd4] rounded-md text-sm font-medium text-white hover:bg-cyan-600 disabled:bg-gray-400"
          >
            {loading ? "Submitting..." : "Submit Request"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssetReturnModal;
